export default "__VITE_ASSET__D25$RtTW__"